import { render, staticRenderFns } from "./Generate-Reportss.vue?vue&type=template&id=be20412c&scoped=true"
import script from "./Generate-Reportss.vue?vue&type=script&lang=js"
export * from "./Generate-Reportss.vue?vue&type=script&lang=js"
import style0 from "./Generate-Reportss.vue?vue&type=style&index=0&id=be20412c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20412c",
  null
  
)

export default component.exports